export class ScreenSizeObserver {
    private windowResizeObserver: ResizeObserver | null = null;
    private windowDotNetRef: any = null;
    private scrollListener: (() => void) | null = null;

    observeWindowSize(dotNetObjectRef: any) {
        this.windowDotNetRef = dotNetObjectRef;
        if (this.windowResizeObserver) return;
        this.windowResizeObserver = new ResizeObserver(() => {
            if (!this.windowDotNetRef) return;
            this.windowDotNetRef.invokeMethodAsync('OnElementSizeChanged', window.innerWidth, window.innerHeight);
        });
        this.windowResizeObserver.observe(document.body);
        this.observeWindowScroll();
    }

    observeWindowScroll() {
        if (this.scrollListener) return;
        this.scrollListener = () => {
            if (!this.windowDotNetRef) return;
            this.windowDotNetRef.invokeMethodAsync('OnScreenScrolled');
        };
        window.addEventListener('scroll', this.scrollListener, true);
    }

    getWindowSizeInfo() {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    disposeWindowSizeObserver() {
        if (this.windowResizeObserver) {
            this.windowResizeObserver.disconnect();
            this.windowResizeObserver = null;
        }
        if (this.scrollListener) {
            window.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = null;
        }
        this.windowDotNetRef = null;
    }
}

(window as any).createScreenSizeObserver = function(dotNetObjectRef:any) {
    const observer = new ScreenSizeObserver();
    observer.observeWindowSize(dotNetObjectRef);
    return observer;
}